<template>
  <div class="star">
      <Header :title="modelTitle" @goMore="starHome" :showMore="true" />
      <div class="users" v-if="list?.length">
          <div class="u-item" @click="toUserCenter(item.userId)" v-for="(item) in list" :key="item.memberId">
              <div class="list-item-link" v-link="linkUrl(item.userId)">
                <img class="avatar" :src="item.icon || config.defaultImg" alt="">
                <p class="info">
                    <span class="main overflow-ellipsis" :title="item.memberName">{{item.memberName}}</span>
                    <span class="sub overflow-ellipsis" :title="item.memberSchool" >{{item.memberSchool}}</span>
                </p>
              </div>
          </div>
      </div>
      <no-data style="padding-top:20px" v-else info="暂无研修之星" url="no-member@2x.png"/>
  </div>
</template>

<script setup>
import {ref, onMounted, computed } from 'vue'
import Header from '@/components/home-common-title/index.vue'
import NoData from '@/components/no-data.vue'
import { useStore } from 'vuex'
import { pageJump } from '@/global/location-transfer'
import { useRouter } from 'vue-router'
import config from '@/global/config'
const store = useStore();
const props = defineProps({
    modelTitle: {
        type: String,
        default: ''
    }
})
const router = useRouter()
const list = ref([]);

const allList = ref([]);


const getList = function(){
    G_transmit('getTrainingStarList', {
        name: 'getTrainingStarList',
        queries: {
            publishState: 1,
            pageIndex: 1,
            pageSize: 6,
            positionType: 2
        }
    }).then(res => {
        list.value = res.data?.rows || []
    });
}

const starHome = function(){
    pageJump({name: 'trainingStar'})
}


const toUserCenter = function(id){
    pageJump({
        name: 'userHomePage',
        query: {
            uId: id
        }
    }, true)
}

function linkUrl(id){
    let path = router.resolve({name: 'userHomePage'}).path;
    return {
        url: `${path}?uId=${id}`,
        className: 'link-item'
    }
}

const getAllList = function(){
    G_transmit('getTrainingStarList', {
        name: 'getTrainingStarList',
        queries: {
            publishState: 1,
            pageIndex: 1,
            pageSize: 7
        }
    }).then(res => {
        allList.value = res.data?.rows || []
    });
}

onMounted(() => {
    getList();
    // getAllList();
})

</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    .users{
        display: flex;
        box-sizing: border-box;
        width: 100%;
        overflow: hidden;
        flex-wrap: wrap;
        .u-item{
            display: flex;
            align-items: center;
            width: calc(33.333% - 40px);
            margin-top: 30px;
            margin-right: 60px;
            cursor: pointer;

            &:nth-child(1), &:nth-child(2) {
                margin-top: 26px;
            }
            &:nth-child(3n){
                margin-right: 0px;
            }

            &:hover {
                .info {
                    color: var(--home-main-color) !important;
                }
            }
            .avatar{
                width:100px;
                height: 100px;
                border: 1px solid #F2F2F2;
                margin-right: 20px;
                border-radius: 50%;
            }
            .info{
                width: calc(100% - 120px);
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                color: var(--color-black);
                flex: 1;
                .main{
                    font-size: 18px;
                    font-weight: bold;
                    margin-bottom: 14px;
                }
                .sub{
                    max-width: 250px;
                    font-size: 14px;
                    font-weight: 400;
                    overflow:hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
        }
        :deep(.link-item){
            width:100%;
            .list-item-link{
                display: flex;
                align-items: center;
            }
        }
    }
 
</style>
